import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import Icon, { ICONS } from '../../general-components/icon';
import * as ModalActions from '../../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../../stores/reducers/modal';
import LoadingSpinner from '../../general-components/loading-spinner';
import { GreenroomState as GS } from '../../../stores/types/types';
import { UpdateTutorialVideoCount } from '../../../connection/greenroom';

export default function ProductTour() {
	const dispatch = useDispatch();

	const token = useSelector((state: GS) => state.SessionReducer.token);

	const [isLoading, setIsLoading] = useState<boolean>(true);

	const closeModal = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: false,
			modalTemplate: MODAL_TEMPLATES.PRODUCT_TOUR,
		}));
	};

	const updateTutorialSeen = async () => {
		if (token) {
			const response = await UpdateTutorialVideoCount(token);

			dispatch({
				type: 'UPDATE_TOKEN_MANUALLY',
				payload: response.token,
			});
		}
	};

	useEffect(() => {
		updateTutorialSeen().catch((error) => console.error(error));
	}, []);

	return (
		<div className="tutorial-video-modal product-tour">
			<div className="tutorial-video-body">
				<div className="tutorial-video-close-icon" onClick={closeModal}>
					<Icon
						name={ICONS.CLOSE}
						size={16}
						color="white"
						className="icon-pointer"
					/>
				</div>
				{isLoading && (
					<LoadingSpinner
						height={36}
						width={36}
						color={'#878793'}
						stroke={10}
					/>
				)}
				<iframe
					src={'https://onthelot.brandlive.com/Product-Tour/en/session/a73421b0-8b44-11ef-b95b-b9f5a99d2ec0'}
					className={classNames('width-full height-full', isLoading && 'display-none')}
					onLoad={() => setIsLoading(false)}
				/>
			</div>
		</div>
	);
}
